import MarkdownIt from "markdown-it";
const md = new MarkdownIt({ linkify: true, breaks: false });

export function renderMarkdown(text) {
  return md.render(text || "");
}
